var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down",
    transform: "translate(-462 -631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40386",
    "data-name": "Path 40386",
    d: "M1479,229.5l-5,5-5-5",
    transform: "translate(-1004 407)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13996",
    "data-name": "Rectangle 13996",
    width: 16,
    height: 16,
    transform: "translate(462 631)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftChevron);
export default __webpack_public_path__ + "static/media/left-chevron.2d1740b6.svg";
export { ForwardRef as ReactComponent };